import { getStore } from '../util';
const getAllTurfs = async() => {

    let url = `/api/turfs`;
    const response =  await fetch(url, {
         headers: {
            'Content-Type': 'application/json',
        }
    });
    if (response.ok) {
        return await response.json();
        
    }
    throw response;
}

const getTurfDetails = async(id, from, to) => {
    console.log(id, from, to)
    if (id && from && to) {
        let url = `/api/turf/${id}?from=${from}&to=${to}`;
        const response =  await fetch(url, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        if (response.ok) {
            return await response.json();
            
        }
        throw response;
    }
}

const book = async(from, to, turfId) => {
    const user = getStore('user');
    if (from && to ) {
        let url = `/api/book`;

        const response =  await fetch(url, {
            method: "POST",
            body: JSON.stringify({from: from, to: to, turfId: turfId}),
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': user.accessToken,
            }
        });
        if (response.ok) {
            return response.json();
        }
        throw response;
    }
}
export { getAllTurfs, getTurfDetails, book }